import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const StaffLetterServices = {
  getStaffLetterList(obj) {
    return httpClient.post(endPoints.getStaffLetterList, obj);
  },
  getStaffLetterDetail(obj) {
    return httpClient.post(endPoints.getStaffLetterDetail, obj);
  },
  getStaffLetterDetailByStaffId(obj) {
    return httpClient.post(endPoints.getStaffLetterDetailByStaffId, obj);
  },
  getDocTempDetail(obj) {
    return httpClient.post(endPoints.getDocTempDetail, obj);
  },
  printStaffLetter(obj) {
    return httpClient.post(endPoints.printStaffLetter, obj);
  },
  addStaffLetter(obj) {
    return httpClient.post(endPoints.addStaffLetter, obj);
  },
  updateStaffLetter(obj) {
    return httpClient.post(endPoints.updateStaffLetter, obj);
  },
  deleteStaffLetter(obj) {
    return httpClient.post(endPoints.deleteStaffLetter, obj);
  },
};

export default StaffLetterServices;



// WEBPACK FOOTER //
// ./src/service/StaffLetterServices.js